import React from 'react';
import Layout from '@app/layouts/_layout';
import { getLayoutProps, getTeamsContent, getTeamsPageContent } from '@app/utils/serverSidePropsUtils';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { TeamAttributes, TeamPageAttributes } from '@app/models/dtos/strapi';
import TeamCard from '@app/components/cards/team-card';
import WorkWithUs from '@app/components/ui/work-with-us';
import RadialGradient from '@app/components/ui/radial-gradient';
import { ILayoutProps } from '@app/models/props/home';

export async function getServerSideProps({ locale }: any) {
    const [teams, teamsPageDetails] = await Promise.all([getTeamsContent(), getTeamsPageContent()]);
    const layoutProps = await getLayoutProps();
    if (!teamsPageDetails)
        return {
            notFound: true
        };
    return {
        props: {
            teams,
            teamsPageDetails,
            ...layoutProps,
            ...(await serverSideTranslations(locale, ['common'], null, ['en', 'nl']))
        }
    };
}

export interface ITeamsProps extends ILayoutProps {
    teams?: Array<TeamAttributes>;
    teamsPageDetails: TeamPageAttributes;
}

function Teams({ teams, settings, socialMedias, teamsPageDetails, locations, products }: ITeamsProps) {
    return (
        <Layout settings={settings} socialMedias={socialMedias} locations={locations} products={products}>
            <RadialGradient />
            <div className="my-[60px] flex w-full flex-col items-center md:my-[160px]">
                <div className="container w-full">
                    <p className="P2 !text-black-1 ">Teams</p>
                    <p className="h2-responsive my-2 max-w-[769px] text-black-1 md:my-6" dangerouslySetInnerHTML={{ __html: teamsPageDetails.title }}></p>
                    <p className="P1 max-w-[384px] !text-black-2">{teamsPageDetails.description}</p>
                    {teams && teams.sort((a, b) => a.order - b.order) && (
                        <div className="flex justify-center md:justify-end">
                            <div className="mb-[60px] mt-10 grid grid-flow-row grid-cols-1  gap-10 sm:grid-cols-2 md:mb-[160px] md:max-w-[860px] md:grid-cols-2 lg:grid-cols-3">
                                {teams.map((team) => (
                                    <TeamCard key={team.id} teamAttributes={team} />
                                ))}
                            </div>
                        </div>
                    )}
                    <WorkWithUs teamsPageDetailsAttributes={teamsPageDetails} />
                </div>
            </div>
        </Layout>
    );
}

export default Teams;
